"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALM_LADDER_CONFIGS = exports.ALM_LADDER_CONFIG_FTP = exports.ALM_LADDER_CONFIG_ERROR_POSITIONS = exports.ALM_LADDER_CONFIG_LCR = exports.ALM_LADDER_CONFIG_NSFR = exports.ALM_LADDER_CONFIG_IRS_BALANCE_SHEET = exports.ALM_LADDER_CONFIG_SLS_BALANCE_SHEET = exports.ALM_LADDER_CONFIG_REPRICING_GAP = exports.ALM_LADDER_CONFIG_LTV = exports.ALM_LADDER_CONFIG_LTL = exports.ALM_LADDER_CONFIG_STL = exports.getFullBreakDownName = exports.getALMLadderConfigByCode = exports.getALMLadderConfigByName = exports.getALMMetricConfigByCode = exports.getALMMetricConfigByName = exports.ALM_METRIC_CONFIGS = exports.ALM_METRIC_CONFIG_B210 = exports.ALM_METRIC_CONFIG_LCR = exports.ALM_METRIC_CONFIG_NSFR = exports.ALM_METRIC_CONFIG_SLR = exports.ALM_METRIC_CONFIG_CRR = exports.ALM_METRIC_CONFIG_VOLATILE_LIAB_RATIO = exports.ALM_METRIC_CONFIG_VOLATILITY_COVER_RATIO = exports.ALM_METRIC_CONFIG_AVAILABLE_ASSETS_RATIO = exports.ALM_METRIC_CONFIG_STABLE_DEPO_ILQ_FUND_RATIO = exports.ALM_METRIC_CONFIG_ILLIQUID_RATIO = exports.ALM_METRIC_CONFIG_STABLE_DEPO_FUND_RATIO = exports.ALM_METRIC_CONFIG_VOL_LIAB_VS_EAR = exports.ALM_METRIC_CONFIG_FTP = exports.ALM_METRIC_CONFIG_WAL = exports.ALM_METRIC_CONFIG_NII = exports.ALM_METRIC_CONFIG_DURATION_GAP = exports.ALM_METRIC_CONFIG_PV01 = exports.ALM_METRIC_CONFIG_PV_GAP = exports.ALM_METRIC_CONFIG_REPRICING_POSITIONS = exports.ALM_METRIC_CONFIG_ERROR_POSITIONS = exports.ALM_METRIC_CONFIG_EQUITIES = exports.ALM_METRIC_CONFIG_LIABILITIES = exports.ALM_METRIC_CONFIG_ASSETS = exports.ALM_BREAKDOWN_CONFIGS = exports.GENERIC_ALM_BREAKDOWN_CONFIGS = exports.ALM_BREAKDOWN_FTP = exports.ALM_BREAKDOWN_EXTERNAL_MIS = exports.ALM_BREAKDOWN_INTERNAL_MIS = exports.ALM_BREAKDOWN_PRODUCT_DETAIL = exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS = void 0;
exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS = {
    name: 'ChartOfAccounts', attributeColumnIdentifier: 'coa',
    code: 'CHART_OF_ACCOUNTS', allowedLevels: 4
};
exports.ALM_BREAKDOWN_PRODUCT_DETAIL = {
    name: 'ProductDetail', attributeColumnIdentifier: 'prd',
    code: 'PRODUCT_DETAIL', allowedLevels: 4
};
exports.ALM_BREAKDOWN_INTERNAL_MIS = {
    name: 'InternalMIS', attributeColumnIdentifier: 'int',
    code: 'INTERNAL_MIS', allowedLevels: 4
};
exports.ALM_BREAKDOWN_EXTERNAL_MIS = {
    name: 'ExternalMIS', attributeColumnIdentifier: 'ext',
    code: 'EXTERNAL_MIS', allowedLevels: 4
};
exports.ALM_BREAKDOWN_FTP = {
    name: 'FTP', attributeColumnIdentifier: 'ftp',
    code: 'FTP', allowedLevels: 4
};
exports.GENERIC_ALM_BREAKDOWN_CONFIGS = [
    exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS,
    exports.ALM_BREAKDOWN_PRODUCT_DETAIL,
    exports.ALM_BREAKDOWN_INTERNAL_MIS,
    exports.ALM_BREAKDOWN_EXTERNAL_MIS,
];
exports.ALM_BREAKDOWN_CONFIGS = [
    exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS,
    exports.ALM_BREAKDOWN_PRODUCT_DETAIL,
    exports.ALM_BREAKDOWN_INTERNAL_MIS,
    exports.ALM_BREAKDOWN_EXTERNAL_MIS,
    exports.ALM_BREAKDOWN_FTP,
];
exports.ALM_METRIC_CONFIG_ASSETS = {
    category: 'BALANCE_SHEET',
    name: 'Assets',
    code: 'ASSETS',
    breakDownConfigs: exports.ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Assets'],
};
exports.ALM_METRIC_CONFIG_LIABILITIES = {
    category: 'BALANCE_SHEET',
    name: 'Liabilities',
    code: 'LIABILITIES',
    breakDownConfigs: exports.ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Liabilities'],
};
exports.ALM_METRIC_CONFIG_EQUITIES = {
    category: 'BALANCE_SHEET',
    name: 'Equities',
    code: 'EQUITIES',
    breakDownConfigs: exports.ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Equity'],
};
exports.ALM_METRIC_CONFIG_ERROR_POSITIONS = {
    category: 'BALANCE_SHEET',
    name: 'ErrorPositions',
    code: 'ERROR_POSITIONS',
    breakDownConfigs: exports.ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM', 'SUM'],
    ladderValueNames: ['Notional', 'Count'],
};
/*
export const ALM_METRIC_CONFIG_REPRICING_ASSETS = {
    category: 'INTEREST_BEARING',
    name: 'RepricingAssets',
    code: 'REPRICING_ASSETS',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_ASSET_WAL = {
    category: 'INTEREST_BEARING',
    name: 'AssetsWAL',
    code: 'ASSET_WAL',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_ASSET_AVERAGE_RATE = {
    category: 'INTEREST_BEARING',
    name: 'AssetAverageRate',
    code: 'ASSET_AVERAGE_RATE',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_ASSET_NII = {
    category: 'INTEREST_BEARING',
    name: 'InterestIncome',
    code: 'ASSET_NII',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_ASSET_PV = {
    category: 'INTEREST_BEARING',
    name: 'AssetsPV',
    code: 'ASSET_PV',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_ASSET_DURATION = {
    category: 'INTEREST_BEARING',
    name: 'AssetsDuration',
    code: 'ASSET_DURATION',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_REPRICING_LIABILITIES = {
    category: 'INTEREST_BEARING',
    name: 'RepricingLiabilities',
    code: 'REPRICING_LIABILITIES',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_LIABILITY_WAL = {
    category: 'INTEREST_BEARING',
    name: 'LiabilitiesWAL',
    code: 'LIABILITY_WAL',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_LIABILITY_AVERAGE_RATE = {
    category: 'INTEREST_BEARING',
    name: 'LiabilityAverageRate',
    code: 'LIABILITY_AVERAGE_RATE',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_LIABILITY_NII = {
    category: 'INTEREST_BEARING',
    name: 'InterestExpense',
    code: 'LIABILITY_NII',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_LIABILITY_DURATION = {
    category: 'INTEREST_BEARING',
    name: 'LiabilitiesDuration',
    code: 'LIABILITY_DURATION',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
export const ALM_METRIC_CONFIG_LIABILITY_PV = {
    category: 'INTEREST_BEARING',
    name: 'LiabilitiesPV',
    code: 'LIABILITY_PV',
    breakDownConfigs: ALM_BREAKDOWN_CONFIGS,
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Amount'],
} as ALMMetricConfig;
*/
exports.ALM_METRIC_CONFIG_REPRICING_POSITIONS = {
    category: 'INTEREST_BEARING',
    name: 'RepricingPositions',
    code: 'REPRICING_POSITIONS',
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'WEIGHTED', 'WEIGHTED', 'SUM', 'SUM'],
    ladderValueNames: ['Repricing Position', 'Repricing Assets', 'Repricing Liabilities', 'Repricing Assets Rate', 'Repricing Liabilities Rate', 'Earnings At Risk', 'Earnings Change 1% Up'],
};
exports.ALM_METRIC_CONFIG_PV_GAP = {
    category: 'INTEREST_BEARING',
    name: 'PVGap',
    code: 'PV_GAP',
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'SUM'],
    ladderValueNames: ['Assets Cash', 'Liabilities Cash', 'Assets Cash PV', 'Liabilities Cash PV'],
};
exports.ALM_METRIC_CONFIG_PV01 = {
    category: 'INTEREST_BEARING',
    name: 'PV01',
    code: 'PV01',
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'SUM'],
    ladderValueNames: ['Assets', 'Liabilities', 'Assets PV01', 'Liabilities PV01'],
};
exports.ALM_METRIC_CONFIG_DURATION_GAP = {
    category: 'INTEREST_BEARING',
    name: 'DurationGap',
    code: 'DURATION_GAP',
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'SUM'],
    ladderValueNames: ['Assets Cash', 'Liabilities Cash', 'Assets Cash PV', 'Liabilities Cash PV'],
};
exports.ALM_METRIC_CONFIG_NII = {
    category: 'INTEREST_BEARING',
    name: 'NetInterestIncome',
    code: 'NII',
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'WEIGHTED', 'WEIGHTED', 'SUM', 'SUM'],
    ladderValueNames: ['Repricing Position', 'Repricing Assets', 'Repricing Liabilities', 'Repricing Assets Rate', 'Repricing Liabilities Rate', 'Earnings At Risk', 'Earnings Change 1% Up'],
};
exports.ALM_METRIC_CONFIG_WAL = {
    category: 'INTEREST_BEARING',
    name: 'WeightedAverageLife',
    code: 'WAL',
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM', 'SUM'],
    ladderValueNames: ['Maturing Assets', 'Maturing Liabilities'],
};
exports.ALM_METRIC_CONFIG_FTP = {
    category: 'INTEREST_BEARING',
    name: 'FTP',
    code: 'FTP',
    breakDownConfigs: [exports.ALM_BREAKDOWN_FTP],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM', 'WEIGHTED', 'SUM'],
    ladderValueNames: ['Average Balance', 'Average Rate', 'Accrued Amount'],
};
exports.ALM_METRIC_CONFIG_VOL_LIAB_VS_EAR = {
    category: 'REGULATORY',
    name: 'VolatileLiabilitiesVsEarningAssetsRatio',
    code: 'VOL_LIAB_VS_EAR',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Positions'],
};
exports.ALM_METRIC_CONFIG_STABLE_DEPO_FUND_RATIO = {
    category: 'REGULATORY',
    name: 'StableDepositFundingRatio',
    code: 'SDFR',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'NONE',
    ladderRollupTypes: ['NONE']
};
exports.ALM_METRIC_CONFIG_ILLIQUID_RATIO = {
    category: 'REGULATORY',
    name: 'IlliquidRatio',
    code: 'ILLIQUID_RATIO',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'NONE',
    ladderRollupTypes: ['NONE']
};
exports.ALM_METRIC_CONFIG_STABLE_DEPO_ILQ_FUND_RATIO = {
    category: 'REGULATORY',
    name: 'StableDepositIlliquidFundingRatio',
    code: 'SDIFR',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'NONE',
    ladderRollupTypes: ['NONE']
};
exports.ALM_METRIC_CONFIG_AVAILABLE_ASSETS_RATIO = {
    category: 'REGULATORY',
    name: 'AvailableAssetsRatio',
    code: 'AVAIL_ASSET_RATIO',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'NONE',
    ladderRollupTypes: ['NONE']
};
exports.ALM_METRIC_CONFIG_VOLATILITY_COVER_RATIO = {
    category: 'REGULATORY',
    name: 'VolatilityCoverRatio',
    code: 'VOL_COVER_RATIO',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'NONE',
    ladderRollupTypes: ['NONE']
};
exports.ALM_METRIC_CONFIG_VOLATILE_LIAB_RATIO = {
    category: 'REGULATORY',
    name: 'VolatileLiabilityRatio',
    code: 'VOL_LIAB_RATIO',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'NONE',
    ladderRollupTypes: ['NONE']
};
exports.ALM_METRIC_CONFIG_CRR = {
    category: 'REGULATORY',
    name: 'CRR',
    code: 'CRR',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM']
};
exports.ALM_METRIC_CONFIG_SLR = {
    category: 'REGULATORY',
    name: 'SLR',
    code: 'SLR',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM']
};
exports.ALM_METRIC_CONFIG_NSFR = {
    category: 'REGULATORY',
    name: 'NSFR',
    code: 'NSFR',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'WEIGHTED',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'SUM'],
    ladderValueNames: ['ASF Value', 'ASF Weighted Value', 'RSF Value', 'RSF Weighted Value']
};
exports.ALM_METRIC_CONFIG_LCR = {
    category: 'REGULATORY',
    name: 'LCR',
    code: 'LCR',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'WEIGHTED',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'SUM'],
    ladderValueNames: ['HQLA Value', 'Weighted HQLA Value', 'Cash', 'Weighted Cash']
};
exports.ALM_METRIC_CONFIG_B210 = {
    category: 'REGULATORY',
    name: 'B210',
    code: 'B210',
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS],
    metricRollupType: 'SUM',
    breakDownRollupType: 'SUM',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Position']
};
exports.ALM_METRIC_CONFIGS = [
    exports.ALM_METRIC_CONFIG_ASSETS,
    exports.ALM_METRIC_CONFIG_LIABILITIES,
    exports.ALM_METRIC_CONFIG_EQUITIES,
    exports.ALM_METRIC_CONFIG_ERROR_POSITIONS,
    // ALM_METRIC_CONFIG_REPRICING_ASSETS,
    // ALM_METRIC_CONFIG_ASSET_WAL,
    // ALM_METRIC_CONFIG_ASSET_AVERAGE_RATE,
    // ALM_METRIC_CONFIG_ASSET_NII,
    // ALM_METRIC_CONFIG_ASSET_PV,
    // ALM_METRIC_CONFIG_ASSET_DURATION,
    // ALM_METRIC_CONFIG_REPRICING_LIABILITIES,
    // ALM_METRIC_CONFIG_LIABILITY_WAL,
    // ALM_METRIC_CONFIG_LIABILITY_AVERAGE_RATE,
    // ALM_METRIC_CONFIG_LIABILITY_NII,
    // ALM_METRIC_CONFIG_LIABILITY_PV,
    // ALM_METRIC_CONFIG_LIABILITY_DURATION,
    exports.ALM_METRIC_CONFIG_REPRICING_POSITIONS,
    exports.ALM_METRIC_CONFIG_NII,
    exports.ALM_METRIC_CONFIG_PV_GAP,
    exports.ALM_METRIC_CONFIG_DURATION_GAP,
    exports.ALM_METRIC_CONFIG_PV01,
    exports.ALM_METRIC_CONFIG_WAL,
    exports.ALM_METRIC_CONFIG_FTP,
    exports.ALM_METRIC_CONFIG_VOL_LIAB_VS_EAR,
    exports.ALM_METRIC_CONFIG_STABLE_DEPO_FUND_RATIO,
    exports.ALM_METRIC_CONFIG_ILLIQUID_RATIO,
    exports.ALM_METRIC_CONFIG_STABLE_DEPO_ILQ_FUND_RATIO,
    exports.ALM_METRIC_CONFIG_AVAILABLE_ASSETS_RATIO,
    exports.ALM_METRIC_CONFIG_VOLATILITY_COVER_RATIO,
    exports.ALM_METRIC_CONFIG_VOLATILE_LIAB_RATIO,
    exports.ALM_METRIC_CONFIG_CRR,
    exports.ALM_METRIC_CONFIG_SLR,
    exports.ALM_METRIC_CONFIG_NSFR,
    exports.ALM_METRIC_CONFIG_LCR,
    exports.ALM_METRIC_CONFIG_B210,
];
function getALMMetricConfigByName(name) {
    return exports.ALM_METRIC_CONFIGS.find((metricConfig) => {
        return metricConfig.name === name;
    });
}
exports.getALMMetricConfigByName = getALMMetricConfigByName;
function getALMMetricConfigByCode(code) {
    return exports.ALM_METRIC_CONFIGS.find((metricConfig) => {
        return metricConfig.code === code;
    });
}
exports.getALMMetricConfigByCode = getALMMetricConfigByCode;
function getALMLadderConfigByName(name) {
    return exports.ALM_LADDER_CONFIGS.find((ladderConfig) => {
        return ladderConfig.name === name;
    });
}
exports.getALMLadderConfigByName = getALMLadderConfigByName;
function getALMLadderConfigByCode(code) {
    return exports.ALM_LADDER_CONFIGS.find((ladderConfig) => {
        return ladderConfig.code === code;
    });
}
exports.getALMLadderConfigByCode = getALMLadderConfigByCode;
function getFullBreakDownName(breakDownQueryConfig, breakDownConfig) {
    let metricConfigName;
    let breakDownConfigName;
    if (typeof breakDownQueryConfig === 'string') {
        metricConfigName = breakDownQueryConfig;
    }
    else {
        metricConfigName = breakDownQueryConfig.name;
    }
    if (typeof breakDownConfig === 'string') {
        breakDownConfigName = breakDownConfig;
    }
    else {
        breakDownConfigName = breakDownConfig.name;
    }
    return `${metricConfigName}.${breakDownConfigName}`;
}
exports.getFullBreakDownName = getFullBreakDownName;
exports.ALM_LADDER_CONFIG_STL = {
    category: 'LADDER',
    name: 'Short Term Liquidity',
    code: 'STL',
    useAllCurrencies: false,
    ladderStructureType: 'TENOR_GROUPINGS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Cash'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'SHORT_TERM',
};
exports.ALM_LADDER_CONFIG_LTL = {
    category: 'LADDER',
    name: 'Long Term Liquidity',
    code: 'LTL',
    useAllCurrencies: false,
    ladderStructureType: 'TENOR_GROUPINGS',
    ladderingType: 'INVERSE_CUMULATIVE',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Position'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'LONG_TERM',
};
exports.ALM_LADDER_CONFIG_LTV = {
    category: 'LADDER',
    name: 'Long Term Valuation',
    code: 'LTV',
    useAllCurrencies: false,
    ladderStructureType: 'TENOR_GROUPINGS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['PV'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'LONG_TERM',
};
exports.ALM_LADDER_CONFIG_REPRICING_GAP = {
    category: 'LADDER',
    name: 'Repricing Gap',
    code: 'REPRICING_GAP',
    useAllCurrencies: false,
    ladderStructureType: 'DATA_TENORS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'WEIGHTED', 'WEIGHTED', 'SUM', 'SUM',],
    ladderValueNames: ['Repricing Position', 'Repricing Asset', 'Repricing Liability', 'Asset Average Rate', 'Liability Average Rate', 'Earnings at Risk', 'Earnings at Risk 1%'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'REPRICING',
};
// export const ALM_LADDER_CONFIG_ST_CCY_POS: ALMLadderConfig = {
//     name: 'Short Term Currency Position',
//     code: 'ST_CCY_POS',
//     useAllCurrencies: true,
//     ladderStructureType: 'TENOR_GROUPINGS',
//     ladderingType: 'CUMULATIVE',
//     ladderRollupTypes: ['SUM'],
//     ladderValueNames: [],
//     breakDownConfigs: [ALM_BREAKDOWN_CHART_OF_ACCOUNTS, ALM_BREAKDOWN_PRODUCT_DETAIL, ALM_BREAKDOWN_EXTERNAL_MIS, ALM_BREAKDOWN_INTERNAL_MIS],
//     bucketingStrategy: 'SHORT_TERM',
// };
// export const ALM_LADDER_CONFIG_LT_CCY_POS: ALMLadderConfig = {
//     name: 'Long Term Currency Position',
//     code: 'LT_CCY_POS',
//     useAllCurrencies: true,
//     ladderStructureType: 'TENOR_GROUPINGS',
//     ladderingType: 'CUMULATIVE',
//     ladderRollupTypes: ['SUM'],
//     ladderValueNames: [],
//     breakDownConfigs: [ALM_BREAKDOWN_CHART_OF_ACCOUNTS, ALM_BREAKDOWN_PRODUCT_DETAIL, ALM_BREAKDOWN_EXTERNAL_MIS, ALM_BREAKDOWN_INTERNAL_MIS],
//     bucketingStrategy: 'LONG_TERM',
// };
exports.ALM_LADDER_CONFIG_SLS_BALANCE_SHEET = {
    category: 'LADDER',
    name: 'SLS Balance Sheet',
    code: 'SLS',
    useAllCurrencies: false,
    ladderStructureType: 'TENOR_GROUPINGS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Position'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'SLS',
};
exports.ALM_LADDER_CONFIG_IRS_BALANCE_SHEET = {
    category: 'LADDER',
    name: 'IRS Balance Sheet',
    code: 'IRS',
    useAllCurrencies: false,
    ladderStructureType: 'TENOR_GROUPINGS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM'],
    ladderValueNames: ['Position'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'SLS',
};
exports.ALM_LADDER_CONFIG_NSFR = {
    category: 'LADDER',
    name: 'NSFR Disclosure',
    code: 'NSFR',
    useAllCurrencies: false,
    ladderStructureType: 'DATA_BREAKDOWN_TENORS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'SUM'],
    ladderValueNames: ['ASF Value', 'ASF Weighted Value', 'RSF Value', 'RSF Weighted Value'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'NSFR',
};
exports.ALM_LADDER_CONFIG_LCR = {
    category: 'LADDER',
    name: 'LCR Ladder',
    code: 'LCR',
    useAllCurrencies: false,
    ladderStructureType: 'DATA_BREAKDOWN_TENORS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM', 'SUM', 'SUM', 'SUM'],
    ladderValueNames: ['HQLA Value', 'Weighted HQLA Value', 'Cash', 'Weighted Cash'],
    breakDownConfigs: [...exports.GENERIC_ALM_BREAKDOWN_CONFIGS],
    bucketingStrategy: 'LONG_TERM',
};
exports.ALM_LADDER_CONFIG_ERROR_POSITIONS = {
    category: 'LADDER',
    name: 'Error',
    code: 'ERROR',
    useAllCurrencies: false,
    ladderStructureType: 'TENOR_GROUPINGS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM', 'SUM'],
    ladderValueNames: ['Notional', 'Count'],
    breakDownConfigs: [exports.ALM_BREAKDOWN_CHART_OF_ACCOUNTS, exports.ALM_BREAKDOWN_PRODUCT_DETAIL, exports.ALM_BREAKDOWN_EXTERNAL_MIS, exports.ALM_BREAKDOWN_INTERNAL_MIS],
    bucketingStrategy: 'LONG_TERM',
};
exports.ALM_LADDER_CONFIG_FTP = {
    category: 'LADDER',
    name: 'FTP Ladder',
    code: 'FTP',
    useAllCurrencies: false,
    ladderStructureType: 'DATA_BREAKDOWN_TENORS',
    ladderingType: 'CUMULATIVE',
    ladderRollupTypes: ['SUM', 'WEIGHTED', 'SUM'],
    ladderValueNames: ['Average Balance', 'Average FTP Rate', 'FTP Accrual'],
    breakDownConfigs: [exports.ALM_BREAKDOWN_FTP],
    bucketingStrategy: 'LONG_TERM',
};
exports.ALM_LADDER_CONFIGS = [
    exports.ALM_LADDER_CONFIG_STL,
    exports.ALM_LADDER_CONFIG_LTL,
    exports.ALM_LADDER_CONFIG_LTV,
    exports.ALM_LADDER_CONFIG_REPRICING_GAP,
    // ALM_LADDER_CONFIG_ST_CCY_POS,
    // ALM_LADDER_CONFIG_LT_CCY_POS,
    exports.ALM_LADDER_CONFIG_SLS_BALANCE_SHEET,
    exports.ALM_LADDER_CONFIG_IRS_BALANCE_SHEET,
    exports.ALM_LADDER_CONFIG_NSFR,
    exports.ALM_LADDER_CONFIG_LCR,
    exports.ALM_LADDER_CONFIG_ERROR_POSITIONS,
    exports.ALM_LADDER_CONFIG_FTP,
];
//# sourceMappingURL=alm-metrics.js.map